import { Container, Typography, Grid, Stack } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Page from '../components/Page';
import {
  AerosDetailsMoreMenuForAero,
  AerosDetailsPistes,
  AerosDetailsGeographiqueInfos,
  AerosDetailsMainInfos,
  AerosDetailsMapDetails
} from '../components/AerosDetails';
import { useTranslation } from '../common/LocalizationProvider';
import { selectAerosArray, selectAerosRunwaysArray, selectSession } from '../createSelectorUtils';

export default function AerosDetails() {
  const navigate = useNavigate();
  const t = useTranslation();
  const location = useLocation();
  const session = useSelector(selectSession);

  const aero =
    useSelector(selectAerosArray).find(
      (item) => item.oaci === (location.state !== null ? location.state.oaci : 0)
    ) || {};

  const runways =
    useSelector(selectAerosRunwaysArray).filter(
      (item) => item.oaci === (location.state !== null ? location.state.oaci : 0)
    ) || {};

  useEffect(() => {
    if (!location.state) {
      navigate('/aeros');
    }
  }, [location.state, navigate]);

  return (
    <Page title="Détails de l'Aérodrome | Click and Take off" openProgress={aero === {}}>
      {aero !== {} && (
        <Container>
          <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
            <Typography variant="h4" sx={{ mb: 5 }}>
              {t('details_aeros')}
            </Typography>
            {session.administrator && <AerosDetailsMoreMenuForAero id={aero.id} />}
          </Stack>
          <Grid container spacing={5} justifyContent="center" alignItems="center">
            <Grid item xs={12} sm={6} md={4}>
              <Stack direction="column" spacing={1}>
                <AerosDetailsMainInfos aero={aero} />

                <AerosDetailsGeographiqueInfos aero={aero} />
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={8}>
              <AerosDetailsMapDetails aero={aero} />
            </Grid>
          </Grid>
          {runways !== {} && (
            <Grid item xs={12} sm={6} md={12}>
              <AerosDetailsPistes runways={runways} aero={aero} />
            </Grid>
          )}
        </Container>
      )}
    </Page>
  );
}
